import { useMutation, useQuery } from "@apollo/client/react";
import { useEffect } from "react";
import UserPreferences from "../constants/userPreferences";
import useAuth, { savePreferencesInDb } from "../context/UserContext";
import { SavePreferenceDocument, UserPreferenceDocument } from "../graphql/types";
import type { UserPreferenceQuery, UserPreferenceQueryVariables } from "../graphql/types";

const usePreferences = ({ preferenceToFetch }: { preferenceToFetch?: UserPreferences }) => {
  const { updateUserPreference } = useAuth();
  const [savePreference] = useMutation(SavePreferenceDocument);
  const { data: preferenceData } = useQuery<UserPreferenceQuery, UserPreferenceQueryVariables>(UserPreferenceDocument, {
    skip: !preferenceToFetch || !savePreferencesInDb,
    variables: { name: preferenceToFetch || "" },
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (preferenceToFetch && preferenceData) {
      updateUserPreference(preferenceToFetch, preferenceData.userPreference);
    }
  }, [preferenceData, preferenceToFetch, updateUserPreference]);

  if (savePreferencesInDb) {
    return {
      savePreference: (name: string, value: boolean | string) =>
        savePreference({ variables: { name, value } }).then(() => {
          updateUserPreference(name, value);
        }),
    };
  }
  return {
    savePreference: (name: string, value: boolean | string) => updateUserPreference(name, value),
  };
};

export { usePreferences };
